<div class="home-cuenta__checks" [formGroup]="checksForm">
  <div>
    <label class="home-cuenta__check" [class.home-cuenta__check--invalid]="isInvalid('terminos')">
      <input type="checkbox" [id]="idPrefix + '-terminos'" formControlName="terminos" />
      <span>
        Aceptas nuestros
        <a
          href="#"
          (click)="openPoliticas('T', $event)"
          (keydown.enter)="openPoliticas('T', $event)"
        >términos y condiciones</a>*.
      </span>
    </label>
    @if (isInvalid('terminos')) {
      <div class="home-cuenta__error">Campo obligatorio</div>
    }
  </div>
  <div>
    <label class="home-cuenta__check" [class.home-cuenta__check--invalid]="isInvalid('datos')">
      <input type="checkbox" [id]="idPrefix + '-datos'" formControlName="datos" />
      <span>
        Aceptas nuestra política de
        <a
          href="#"
          (click)="openPoliticas('P', $event)"
          (keydown.enter)="openPoliticas('P', $event)"
        >tratamiento de datos personales</a>*.
      </span>
    </label>
    @if (isInvalid('datos')) {
      <div class="home-cuenta__error">Campo obligatorio</div>
    }
  </div>
</div>

<button
  type="button"
  class="home-cuenta__submit"
  id="btn-home-crear-cuenta"
  [disabled]="!canSubmit"
  [attr.aria-disabled]="!canSubmit"
  (click)="onSubmit()"
>
  Crear cuenta
</button>

@if (showBackLink) {
  <button type="button" class="home-cuenta__back-link" (click)="onBack()">
    Volver atrás
  </button>
}

<app-home-cuenta-politicas-modal
  [open]="modalOpen"
  [tipo]="modalTipo"
  (closed)="onPoliticasClosed()"
  (accepted)="onPoliticasAccepted($event)"
></app-home-cuenta-politicas-modal>
